import { useQuery } from '@tanstack/react-query';
import { ResolvedInvitation } from '@zond/api-interfaces';
import { client } from '../../../../client';

export function useInvitations() {
  return useQuery<ResolvedInvitation[]>({
    queryKey: ['invitations'],
    queryFn: async () => {
      const { data } = await client.get<ResolvedInvitation[]>('/invitations');
      return data;
    },
  });
}
